import type { TSession } from "@/types"
import { usePermissions } from "./usePermissions"

export function useSessionPermission({ visibility }: Pick<TSession, "visibility">) {
  const { isAdmin, isManager } = usePermissions()

  if (isAdmin || visibility == "public") return true
  if (isManager && visibility == "managers") return true

  return false
}
